var svgns = 'http://www.w3.org/2000/svg';
var xlinkns = 'http://www.w3.org/1999/xlink';
var SvgElement = /** @class */ (function () {
    function SvgElement(props, child) {
        this.el = document.createElementNS(svgns, props.tagName);
        this.el.setAttribute('xmlns', svgns);
        for (var name_1 in props.attrs) {
            if (!props.attrs.hasOwnProperty(name_1)) {
                continue;
            }
            // @ts-ignore
            var value = props.attrs[name_1];
            if (name_1 !== 'viewBox' && name_1 !== 'preserveAspectRatio') {
                name_1 = name_1.replace(/[A-Z]/g, function (m) {
                    return '-' + m.toLowerCase();
                });
            }
            if (name_1 === 'href' || name_1 === 'xlink:href') {
                this.el.setAttributeNS(xlinkns, 'href', value);
            }
            else if (value !== undefined) {
                this.el.setAttribute(name_1, value);
            }
        }
        if (child) {
            for (var _i = 0, child_1 = child; _i < child_1.length; _i++) {
                var ch = child_1[_i];
                this.el.appendChild(ch.el);
            }
        }
    }
    SvgElement.prototype.valueOf = function () {
        return this.el;
    };
    return SvgElement;
}());
export { SvgElement };
